import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { ClosetDoorsStandardService } from '../../services/configurators-2d/applications/closet-doors-standard.service';
import { TranslateService } from '@ngx-translate/core';
import { logError } from 'src/app/services/helpers/sentry.helper';

@Component({
  selector: 'ng-casto-closet-doors-structure-info',
  templateUrl: './closet-doors-structure-info.component.html',
})
export class ClosetDoorsStructureInfoComponent implements OnInit {
  doorTypes!: any[];
  currentLang!: string;

  constructor(
    public modalService: ModalService,
    private closetDoorsService: ClosetDoorsStandardService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.currentLang = this.translate.getBrowserLang();
    this.closetDoorsService
      .getDoorTypes(1)
      .then(result => {
        this.doorTypes = result;
      })
      .catch(function (error) {
        alert(error);
        logError(error);
      });
  }
}
